import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import {
  FinalScore,
  GameResult,
  Match,
  TeamScores,
} from '@/modules/players/v2/tabs/rating-history/types';

export const calculateGameResults = (
  teamOneScores: TeamScores,
  teamTwoScores: TeamScores
): GameResult[] => {
  const results: GameResult[] = [];
  if (Number(teamOneScores.gameOneScore) !== 0 || Number(teamTwoScores.gameOneScore) !== 0) {
    results.push({
      teamOneScore: Number(teamOneScores.gameOneScore),
      teamTwoScore: Number(teamTwoScores.gameOneScore),
    });
  }

  if (Number(teamOneScores.gameTwoScore) !== 0 || Number(teamTwoScores.gameTwoScore) !== 0) {
    results.push({
      teamOneScore: Number(teamOneScores.gameTwoScore),
      teamTwoScore: Number(teamTwoScores.gameTwoScore),
    });
  }

  if (Number(teamOneScores.gameThreeScore) !== 0 || Number(teamTwoScores.gameThreeScore) !== 0) {
    results.push({
      teamOneScore: Number(teamOneScores.gameThreeScore),
      teamTwoScore: Number(teamTwoScores.gameThreeScore),
    });
  }

  if (Number(teamOneScores.gameFourScore) !== 0 || Number(teamTwoScores.gameFourScore) !== 0) {
    results.push({
      teamOneScore: Number(teamOneScores.gameFourScore),
      teamTwoScore: Number(teamTwoScores.gameFourScore),
    });
  }

  if (Number(teamOneScores.gameFiveScore) !== 0 || Number(teamTwoScores.gameFiveScore) !== 0) {
    results.push({
      teamOneScore: Number(teamOneScores.gameFiveScore),
      teamTwoScore: Number(teamTwoScores.gameFiveScore),
    });
  }

  return results;
};

export const calculateFinalScore = (gameResults: GameResult[]): FinalScore => {
  const numberOfGamesTeamOneWon = gameResults.filter(
    (gameResult) => gameResult.teamOneScore > gameResult.teamTwoScore
  ).length;
  return {
    numberOfGamesTeamOneWon: numberOfGamesTeamOneWon,
    numberOfGamesTeamTwoWon: gameResults.length - numberOfGamesTeamOneWon,
  };
};

const getPlayerImage = (image?: string | null) => (image ? getCDNURL(image, 40, 40) : '');

export const transformMatch = (matchDto: Match): Match => {
  return {
    ...matchDto,
    moduleDate: new Date(matchDto.moduleDate),
    teamOnePlayerOne: {
      ...matchDto.teamOnePlayerOne,
      playerImage: getPlayerImage(matchDto.teamOnePlayerOne?.playerImage),
    },
    teamOnePlayerTwo: matchDto.teamOnePlayerTwo
      ? {
          ...matchDto.teamOnePlayerTwo,
          playerImage: getPlayerImage(matchDto.teamOnePlayerTwo?.playerImage),
        }
      : null,
    teamTwoPlayerOne: {
      ...matchDto.teamTwoPlayerOne,
      playerImage: getPlayerImage(matchDto.teamTwoPlayerOne?.playerImage),
    },
    teamTwoPlayerTwo: matchDto.teamTwoPlayerTwo
      ? {
          ...matchDto.teamTwoPlayerTwo,
          playerImage: getPlayerImage(matchDto.teamTwoPlayerTwo?.playerImage),
        }
      : null,
  };
};

export const formatAndFilterMatches = (matchesDto: Match[]): Match[] => {
  return matchesDto
    .filter((match) => match.type === 'E' && match.teamOnePlayerOne && match.teamTwoPlayerOne)
    .map((match) => transformMatch(match));
};
